import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'duration',
    standalone: false
})
export class DurationPipe implements PipeTransform {
  //Affiche une durée en heures/minutes/secondes. Seules 2 unités sont affichées au maximum.
  // Ex : 122000 -> "2m 2s", 3662000 -> "1h 1m"
  transform(durationInMs: number|undefined): string {
    if (durationInMs === undefined) {
      return '';
    }
    const durationParts = [];
    const durationInSeconds = Math.floor(durationInMs / 1000);
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds - hours * 3600) / 60);
    const seconds = Math.round(durationInSeconds - hours * 3600 - minutes * 60);
    if (hours) {
      durationParts.push(hours + 'h');
    }
    if (minutes) {
      durationParts.push(minutes + 'm');
    }
    if (seconds) {
      durationParts.push(seconds + 's');
    }
    return durationParts.slice(0, 2).join(' ');
  }

}
